import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-range',
  template: `
    <div class="range-container">
      <label *ngIf="to.label">{{ to.label }}</label>
      <div class="range-input-group">
        <input type="range"
               [formControl]="formControl" 
               [formlyAttributes]="field"
               [min]="to.min" 
               [max]="to.max" 
               [step]="to.step"
               class="range-slider" />
        <input type="number"
               [formControl]="formControl"
               [min]="to.min"
               [max]="to.max"
               [step]="to.step"
               [placeholder]="to.placeholder || 'Enter value'"
               class="range-input form-control" />
      </div>
    </div>
  `,
  styles: [`
    .range-container {
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
    }
    .range-input-group {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .range-slider {
      flex: 1;
      margin: 0;
    }
    .range-input {
      width: 120px;
      min-width: 120px;
    }
    label {
      margin-bottom: 0.5rem;
      font-weight: 500;
    }
  `]
})
export class RangeTypeComponent extends FieldType {}
